<template>
  <div>
    <transition name="el-fade-in-linear" mode="out-in">
      <div v-if="!mapSearch" key="TEXT_SEARCH" class="verification-individual col-md-12 card" v-loading="selecting" element-loading-spinner="qc-spinner">
        <div v-if="showHeader" class="card-header">
          <h4 class="card-title">
            <span v-if="!hideIcon" class="pull-left ystarter" style="width: 100px"><i class="qc2-edu fa-3x"/></span>
            <span>{{title}}</span>
          </h4>
          <div v-if="$store.state.isIndividual" class="category">Select an institute to verify where you studied at:</div>
          <div v-else class="category">Select an institute to verify where an individual studied at:</div>
        </div>
        <div class="card-content row form-horizontal">
          <div v-if="previousInstitutes.length > 0" class="form-group">
            <label class="col-sm-2 control-label">Use a previous institute?</label>
            <div class="col-sm-10">
              <el-select placeholder="New Institute" :value="null" @change="selectInstitute($event.id)">
                <el-option key="-1" :value="null" label="New Institute" />
                <el-option v-for="institute, index in previousInstitutes" :key="index" :value="institute" :label="institute.name">
                  <div v-if="institute.names && institute.names.length > 0">
                    <div v-for="name, index in institute.names">{{name.name}}</div>
                  </div>
                  <div v-else>{{institute.name}}</div>
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="form-group">
            <div class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-2 control-label">Institute name</label>
                <div class="col-sm-10">
                  <el-input placeholder="Start typing to search..." prefix-icon="el-icon-search" v-model="query"></el-input>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Country</label>
                <div class="col-sm-10">
                  <el-select
                        style="width: 100%"
                        v-model="region"
                        :value="region"
                        value-key="name"
                        :filterable="true"
                        :clearable="true"
                        @clear="region = undefined"
                        placeholder="All">
                        <!--@input="searchInstitutes">-->
                    <el-option v-for="region in regionRefData" :key="region.id" :value="region" :label="region.name" />
                  </el-select>
                </div>
              </div>
              <div class="col-sm-12">
                <el-tooltip class="item" effect="light" content="Clear all search filters">
                  <button @click.prevent="clearFilters" class="btn btn-default pull-right"><i class="fa fa-refresh"></i></button>
                </el-tooltip>
              </div>
            </div>
          </div>
          <institute-table 
            v-if="query || region"
            :query="query"
            :region="region"
            :hidePrice="hidePrice"
            @selectInstitute="selectInstitute"
            @select="$emit('select', $event)"
          />
        </div>
      
        <slot name="actions" />
      </div>
      <div v-if="mapSearch" key="MAP_SEARCH" class="verification-individual col-md-12 card" v-loading="selecting" element-loading-spinner="qc-spinner">
        <div v-if="showHeader" class="card-header">
          <h4 class="card-title">Institute Map<button @click="mapSearch = false" class="btn pull-right">Search</button></h4>
          <div class="category">Select a country to view institutes available:</div>
        </div>
        <div class="card-content row form-horizontal">
          Map search disabled for now. <button @click="mapSearch = false" class="btn pull-right">Search</button>
        </div>
      </div>
    </transition>
  </div>
</template>
<style>
  .transition-box {
    margin-bottom: 10px;
    width: 200px;
    height: 100px;
    border-radius: 4px;
    background-color: #409EFF;
    text-align: center;
    color: #fff;
    padding: 40px 20px;
    box-sizing: border-box;
    margin-right: 20px;
  }
</style>
<script>
  import CoverageMap from 'src/views/Verifications/components/CoverageMap'
  import InstituteTable from './InstituteTable'
  import ModalInfoOnlyInstitute from 'src/components/ModalPlugin/ModalInfoOnlyInstitute'

  export default {
    name: 'institute-select',
    components: {
      CoverageMap,
      ModalInfoOnlyInstitute,
      InstituteTable
    },
    $_veeValidate: {
      name() {
        return "institute";
      },
      value() {
        return null;
      }
    },
    props: {
      title: {type: String, default: "Institute Search"},
      showHeader: {type: Boolean, default: true},
      hidePrice: {type: Boolean, default: false},
      hideIcon: {type: Boolean, default: true},
      application: {type: Object, default: null},
      previousInstitutes: {type: Array, default: function () {
        return []
      }},
      startMap : {type: Boolean, default: false}
    },
    data () {
      return {
        loading: false,
        query: null,
        region: undefined,
        regionRefData: [],
        filtersOpen: true,
        selecting: false,
        mapSearch: this.startMap
      }
    },
    mounted () {
      this.$api.listRegions()
        .then(response => {
          this.regionRefData = response
        })
        .catch(error => {
          console.log("Failed to load regions")
        })
    },
    computed: {
      filtersCount () {
        var count = 0
        if(this.query) count++
        if(this.region) count++
        return count > 0 ? "(" + count + ")" : ""
      }
    },
    methods: {
      selectInstitute(idOrInstitute) {
        this.selecting = true
        this.$store.state.minYear = null
        this.$store.state.savedVerificationData.instituteId = idOrInstitute
        this.$api.searchVerifications();      
        if(idOrInstitute.id && !this.application) {
          this.$emit('select', idOrInstitute)
        } else {
          this.$service.buildInstitute(idOrInstitute.id ? idOrInstitute.id : idOrInstitute, null, this.application ? this.application.id : null)
          .then(response => {
            if(response.readOnly) {
              this.$modal.show(ModalInfoOnlyInstitute, {institute: response})
              this.selecting = false
            } else {
              this.$emit('select', response)
            }
            if(response.minYear != null) {
              this.$store.state.minYear = response.minYear
            }
          })
          .catch(error => {
            this.selecting = false
            console.log(error)
          })
        }
      },
      clearFilters () {
        this.query = null
        this.region = undefined
      }
    }
  }
</script>